import Input from "components/semantic/Input";
import React, { FC } from "react";
import QuestionBox from "./QuestionBox";

interface FinancialOccupationProps {
  questions: any;
  padding: string;
  formProps: any;
}

const FinancialOccupation: FC<FinancialOccupationProps> = ({ questions, padding, formProps }) => {
  const { values, setFieldValue } = formProps;

  return (
    <div className="md:border md:rounded-lg md:mx-5 md:-mt-0.5 md:mb-4">
      <QuestionBox question={questions?.Question} SNo={questions?.S_No} formProps={formProps} Id={questions?.Id} />

      {questions?.SubQuestion && (
        <div className={`bg-[#F4F5FA] ${padding} ${values[questions?.Id] ? "slide-down" : "slide-up"} md:rounded-b-lg`}>
          {questions?.SubQuestion.map((subQuestions: any, i: number) => {
            if (subQuestions?.QuestionType === "Custom") {
              return (
                <div key={i} className="w-full py-2 border-b border-border-color">
                  <p className="font-bold text-sm min-w-72 ">{subQuestions?.Question}</p>
                  {subQuestions?.Fields &&
                    subQuestions?.Fields.map((customFields: any, customIndex: number) => {
                      return <Input key={customIndex} name={customFields.Name} label={customFields.Name} placeholder={customFields.Name} value={values?.[subQuestions?.Id]?.[customFields?.Id]} onChange={(e) => setFieldValue(`${subQuestions?.Id}.${customFields?.Id}`, e.target.value)} />;
                    })}
                </div>
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

export default FinancialOccupation;
